var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { UIElement } from "./UIElement.js";
import { scaleFont } from "./utils.js";
import { InputEventType } from "../inputs/InputManager.js";
import "./Rectangle.js";
import "nanoid";
import "lodash";
import "./UIService.js";
import "../global-33d5eebf.js";
import "../utils/playSound.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "../console/flags.js";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
const defaultStyle = {
  position: "absolute",
  color: "white",
  fontFamily: "YageFont",
  fontSize: `12px`,
  borderStyle: "solid",
  borderWidth: "1px",
  outline: "none",
  cursor: "pointer",
  textAlign: "center",
  padding: "0",
  margin: "0",
  fontWeight: "bold",
  fontStyle: "normal",
  textDecoration: "none",
  display: "flex",
  alignItems: "center",
  overflow: "visible",
  justifyContent: "center",
  textShadow: "1px 1px 4px black",
  userSelect: "none",
  pointerEvents: "auto"
};
class Button extends UIElement {
  constructor(bounds, config) {
    super(
      bounds,
      {
        focusStyle: {
          outline: "2px solid #2FA6FF"
        },
        focusable: true,
        ...config
      },
      defaultStyle
    );
    __publicField(this, "_hasChanged", true);
    __publicField(this, "textElement", document.createElement("span"));
  }
  onClickInternal(playerIndex) {
    var _a, _b;
    return (_b = (_a = this._config).onClick) == null ? void 0 : _b.call(_a, playerIndex);
  }
  onMouseDownInternal(playerIndex) {
    var _a, _b;
    return (_b = (_a = this._config).onMouseDown) == null ? void 0 : _b.call(_a, playerIndex);
  }
  onMouseUpInternal(playerIndex) {
    var _a, _b;
    return (_b = (_a = this._config).onMouseUp) == null ? void 0 : _b.call(_a, playerIndex);
  }
  onBlurInternal(playerIndex) {
    if (this._config.onBlur) {
      this._config.onBlur(playerIndex);
    }
  }
  onFocusInternal(playerIndex) {
    if (this._config.onFocus) {
      this._config.onFocus(playerIndex);
    }
  }
  onMouseEnterInternal(playerIndex) {
    if (this._config.onMouseEnter) {
      this._config.onMouseEnter(playerIndex);
    }
  }
  onMouseLeaveInternal(playerIndex) {
    if (this._config.onMouseLeave) {
      this._config.onMouseLeave(playerIndex);
    }
  }
  createElement() {
    const element = document.createElement("button");
    element.id = this.id;
    element.appendChild(this.textElement);
    if (this._config.focusable) {
      element.classList.add("focusable");
    }
    if (this._config.captureFocus !== void 0 && this._config.captureFocus > -1) {
      element.classList.add("captureFocus" + this._config.captureFocus);
      this.uiService.clearFocusedElementByPlayerIndex(this._config.captureFocus);
    }
    if (this._config.autoFocus) {
      element.classList.add("autoFocus");
    }
    return element;
  }
  handleConfigChange(key, value) {
    if (this.destroyed) {
      return;
    }
    if (key === "label") {
      this._config.label = value;
      this.textElement.innerText = value;
      return;
    }
    if (key === "fontSize") {
      this._config.fontSize = value;
      const scales = this.getScales();
      this.element.style.fontSize = `${scaleFont(value, scales[0] * scales[1] * scales[2])}px`;
      return;
    }
    super.handleConfigChange(key, value);
  }
  _update() {
    super._update();
    if (!this.isVisible()) {
      return;
    }
    const buttonElement = this.element;
    if (!buttonElement) {
      return;
    }
    const scales = this.getScales();
    buttonElement.style.fontSize = `${scaleFont(this.config.fontSize || 12, scales[0] * scales[1] * scales[2])}px`;
    this.textElement.innerText = this._config.label;
    let pointerType = "mouse";
    buttonElement.onpointerdown = (e) => {
      pointerType = e.pointerType;
    };
    buttonElement.onclick = (e) => {
      const playerIndex = this.uiService.getPlayerEventIndex(
        pointerType === "mouse" ? InputEventType.MOUSE : InputEventType.TOUCH,
        0,
        this
      );
      if (playerIndex === -1) {
        e.stopPropagation();
        return;
      }
      this.onMouseEnter(e, true);
      if (this.onClick(playerIndex) === false) {
        e.stopPropagation();
      }
    };
    buttonElement.onmousedown = (e) => {
      const playerIndex = this.uiService.getPlayerEventIndex(InputEventType.MOUSE, 0);
      if (playerIndex === -1) {
        e.stopPropagation();
        return;
      }
      if (this.onMouseDown(playerIndex) === false) {
        e.stopPropagation();
      }
    };
    buttonElement.onmouseup = (e) => {
      const playerIndex = this.uiService.getPlayerEventIndex(InputEventType.MOUSE, 0);
      if (playerIndex === -1) {
        e.stopPropagation();
        return;
      }
      if (this.onMouseUp(playerIndex) === false) {
        e.stopPropagation();
      }
    };
    buttonElement.onmouseenter = (e) => {
      this.onMouseEnter(e);
    };
    buttonElement.onmouseleave = () => {
      this.onMouseLeave();
    };
  }
}
export {
  Button
};
//# sourceMappingURL=Button.js.map
